// https://github.com/simple-uploader/Uploader#configuration
export interface AssetUploaderFile {
  id: number
  name: string
  fileType: string
  size: number
  file: File
  resume: () => void
  cancel: () => void
  retry: () => void
  getExtension: () => string
}

// 当前 UI 中文件状态
export enum AssetFileStatus {
  waiting,
  uploadStart,
  uploading,
  uploadAlready,
  uploadSuccess,
  uploadError,
}

// 文件的额外属性，为了实现弹框中的功能，扩展的 file 能力
export interface AssetFileExtraProp {
  id: number
  errorMsg: string
  status: AssetFileStatus
  size: number
  name: string
  file_url: string // 上传返回的私有地址
  progress: number // 上传进度 0-100
  md5: string // 计算的 md5 值，如果没有计算出来，不允许上传
}
